import styled from 'styled-components';

export const ImageContainer = styled.div`
  /* padding: 3px; */
  box-sizing: border-box;
  max-width: 336px;
  max-height: 336px;
  position: relative;
  z-index: 1;
`;

export const MediaRow = styled.div`
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 100%;
  max-height: 250px;
`;

export const ImageItem = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const MediaWithoutCaption = styled.div`
  /* left: 0;
  background: linear-gradient(0deg,rgba(0, 0, 0, .3),rgba(0, 0, 0, 0));
  bottom: 0;
  height: 28px;
  position: absolute;
  width: 100%;
  z-index: 2; */
`;

export const MediaTag = styled.img`
  flex: none;
  width: 100%;
`;